"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MatchingHeaderLabels_1 = __importDefault(require("@Components/MatchComponents/MatchRecordingGroups/MatchRecordingGroupsHeader/MatchingHeaderLabels"));
const MatchRecordingGroupsHeader = (props) => {
    const { totalCount, selectedCount, currentCount } = props;
    return (react_1.default.createElement("div", { className: "results-header" },
        react_1.default.createElement("div", { className: "results-count" }, totalCount !== 0 && (react_1.default.createElement("p", null, `Showing 1 - ${currentCount} of ${totalCount > 200 ? '200+' : totalCount} results`))),
        totalCount > 0 && react_1.default.createElement(MatchingHeaderLabels_1.default, { selectedListLength: selectedCount })));
};
exports.default = MatchRecordingGroupsHeader;
